module.exports = __webpack_public_path__ + "img/store_vip_benefit_follower.a28693c2.png";